import { HTMLParser } from '@gik/ui';
import React from 'react';
import { isFoodType } from '../components/EventForm/utils';
import { ICalendarEntry } from '../models/Calendar';
import { CalendarEventTypeIds } from '../models/CalendarEventTypes';

export function getRequestDetailsTabs(entry: ICalendarEntry, isOrganizer?: boolean, isClaimer?: boolean) {
  const requestDetailTabs = [
    {
      title: `Description`,
      content: entry.description ? (
        <div>
          <HTMLParser rawHtml={entry.description} />
        </div>
      ) : (
        <div className="gik-text-muted">{'No description was provided for this request.'}</div>
      ),
    },
  ];

  if (isOrganizer || isClaimer) {
    if (isFoodType(entry.typeId)) {
      requestDetailTabs.push({
        title: `Delivery Instructions`,
        content: entry.deliveryInstructions ? (
          <div>
            <HTMLParser rawHtml={entry.deliveryInstructions} />
          </div>
        ) : (
          <div className="gik-text-muted">{'No delivery instructions were provided for this request.'}</div>
        ),
      });
    }
    if (entry.emergencyContactInfo) {
      const title = entry.typeId === CalendarEventTypeIds.SeniorCare ? `Contact Info` : `Emergency Contact`;
      requestDetailTabs.push({
        title,
        content: (
          <div>
            <HTMLParser rawHtml={entry.emergencyContactInfo} />
          </div>
        ),
      });
    }
    if (entry.pickupLocation) {
      requestDetailTabs.push({
        title: `Pickup`,
        content: (
          <div>
            <HTMLParser rawHtml={entry.pickupLocation} />
          </div>
        ),
      });
    }
    if (entry.dropoffLocation) {
      requestDetailTabs.push({
        title: `Dropoff`,
        content: (
          <div>
            <HTMLParser rawHtml={entry.dropoffLocation} />
          </div>
        ),
      });
    }
  }

  return requestDetailTabs;
}
